import eventBus from '@/helpers/eventBus';
import CONTRATO_MINUTAS_ACUERDOS from '@/graphql/querys/administracion/minutas/contratoMinutasAcuerdos.gql';
import AGREGAR_MINUTA_ACUERDO from '@/graphql/mutations/administracion/minutas/acuerdos/agregarContratoMinutaAcuerdo.gql';
import ACTUALIZAR_MINUTA_ACUERDO from '@/graphql/mutations/administracion/minutas/acuerdos/actualizarContratoMinutaAcuerdo.gql';
import REMOVER_MINUTA_ACUERDO from '@/graphql/mutations/administracion/minutas/acuerdos/removerContratoMinutaAcuerdo.gql';
import CONTRATO_MINUTAS from '@/graphql/querys/administracion/minutas/contratoMinutas.gql';

export default {
  apollo: {
    contratoMinutas: {
      query: CONTRATO_MINUTAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    async mixAgregarAcuerdo() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { acuerdo } = this;
      const { idMinuta } = this;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_MINUTA_ACUERDO,
          variables: { minutaAcuerdo: acuerdo },
          update: (store, { data: { agregarContratoMinutaAcuerdo } }) => {
            const data = store
              .readQuery({
                query: CONTRATO_MINUTAS_ACUERDOS,
                variables: {
                  idMinuta,
                },
              });
            data.contratoMinutasAcuerdos.push(agregarContratoMinutaAcuerdo);
            store.writeQuery({
              query: CONTRATO_MINUTAS_ACUERDOS,
              variables: {
                idMinuta,
              },
              data,
            });
            this.mixAgregarAcuerdoEnMinutas(store, agregarContratoMinutaAcuerdo);
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
          eventBus.$emit('acuerdos-vencidos-actualizar');
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEditarAcuerdo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      const { idMinuta } = this.minutaAcuerdoEditar;
      const { id } = this.minutaAcuerdoEditar;
      const { acuerdo } = this;
      await this.$apollo.mutate({
        mutation: ACTUALIZAR_MINUTA_ACUERDO,
        variables: {
          id,
          minutaAcuerdo: acuerdo,
        },
        update: (store, { data: { actualizarContratoMinutaAcuerdo } }) => {
          const data = store
            .readQuery({
              query: CONTRATO_MINUTAS_ACUERDOS,
              variables: {
                idMinuta,
              },
            });
          const { contratoMinutasAcuerdos } = data;
          const index = contratoMinutasAcuerdos
            .findIndex((a) => a.id === actualizarContratoMinutaAcuerdo.id);
          if (index !== -1) {
            contratoMinutasAcuerdos.splice(index, 1, actualizarContratoMinutaAcuerdo);
          }
          store.writeQuery({
            query: CONTRATO_MINUTAS_ACUERDOS,
            variables: {
              idMinuta,
            },
            data,
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
        eventBus.$emit('acuerdos-vencidos-actualizar');
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarAcuerdo() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      const idAcuerdo = this.minutaAcuerdoEliminar.id;
      const { idMinuta } = this.minutaAcuerdoEliminar;
      await this.$apollo.mutate({
        mutation: REMOVER_MINUTA_ACUERDO,
        variables: {
          id: idAcuerdo,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_MINUTAS_ACUERDOS,
            variables: {
              idMinuta,
            },
          };
          const data = store.readQuery(query);
          const index = data.contratoMinutasAcuerdos
            .findIndex(({ id }) => id === idAcuerdo);
          if (index !== -1) {
            data.contratoMinutasAcuerdos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
          this.mixEliminarAcuerdoEnMinutas(store, this.minutaAcuerdoEliminar);
        },
      }).then(() => {
        this.mixMensajeSuccess();
        eventBus.$emit('acuerdos-vencidos-actualizar');
      }).catch((err) => {
        this.mixMensajeError(err);
      });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixAgregarAcuerdoEnMinutas(store, acuerdo) {
      const { idContrato } = this.$route.params;
      const { idMinuta } = acuerdo;
      const query = {
        query: CONTRATO_MINUTAS,
        variables: { idContrato },
      };
      const { contratoMinutas } = store.readQuery(query);
      const contratoMinutasCopia = contratoMinutas.slice();
      const minutaEncontrada = contratoMinutasCopia
        .find(({ id }) => id === idMinuta);
      minutaEncontrada.acuerdos.push(acuerdo);
      const index = contratoMinutasCopia
        .findIndex(({ id }) => id === idMinuta);
      if (index !== -1) {
        contratoMinutasCopia.splice(index, 1, minutaEncontrada);
      }
      store.writeQuery({
        ...query,
        data: {
          contratoMinutas: contratoMinutasCopia,
        },
      });
    },
    async mixEliminarAcuerdoEnMinutas(store, acuerdo) {
      const { idContrato } = this.$route.params;
      const { idMinuta } = acuerdo;
      const idAcuerdo = acuerdo.id;
      const query = {
        query: CONTRATO_MINUTAS,
        variables: { idContrato },
      };
      const { contratoMinutas } = store.readQuery(query);
      const contratoMinutasCopia = contratoMinutas.slice();
      const minutaEncontrada = contratoMinutasCopia
        .find(({ id }) => id === idMinuta);
      let index = minutaEncontrada.acuerdos
        .findIndex(({ id }) => id === idAcuerdo);
      if (index !== -1) {
        minutaEncontrada.acuerdos.splice(index, 1);
      }
      index = contratoMinutasCopia
        .findIndex(({ id }) => id === idMinuta);
      if (index !== -1) {
        contratoMinutasCopia.splice(index, 1, minutaEncontrada);
      }
      store.writeQuery({
        ...query,
        data: {
          contratoMinutas: contratoMinutasCopia,
        },
      });
    },
  },
};
